import { UTM_TAG } from "@/enums/utm-tags";

export const isUtmTaggedUrl = routeQueryObj => {
  return [
    UTM_TAG.UTM_SOURCE,
    UTM_TAG.UTM_MEDIUM,
    UTM_TAG.UTM_CAMPAIGN,
    UTM_TAG.UTM_CONTENT
  ].every(tag => tag in routeQueryObj);
};
